import { VITE_AZURE_AUTH_TENANT_ID } from '@src/main/env';
import { AreaDashboard } from '@src/main/modules/common/area/domain/AreaDashboard';

export interface Dashboard {
  id: string;
  artifactId: string;
  workspaceId?: string;
  name: string;
  area: AreaDashboard;
  artifactType:
    | 'PowerBIReport'
    | 'PaginatedReport'
    | 'PowerBIRepository'
    | 'App'
    | 'Dashboard'
    | 'PowerApp'
    | 'LookerStudio';
  originalName: string;
  keyTags: string[];
  tags: string[];
  description?: string;
  isCertified: boolean;
  isShowAll: boolean;
  refreshDate?: Date;
  views?: number;
  syncStatus: string;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  haveAccess: boolean;
  repositoryType: string | null;
  allEmployees: boolean;
}

export interface DashboardCreate {
  id: string;
  name: string;
  artifactType:
    | 'PowerBIReport'
    | 'PaginatedReport'
    | 'PowerBIRepository'
    | 'App'
    | 'Dashboard'
    | 'PowerApp'
    | 'LookerStudio';
  keyTags: string[];
  tags: string[];
  description: string;
  areaId?: string;
  subareaId?: string;
  subsubareaId?: string;
  artifactUrl: string;
  artifactId?: string;
  workspaceId?: string;
  isCertified: boolean;
  showAll: boolean;
  repositoryType: string | null;
}

export const mapDashboardToDashboardCreate = (dashboard: Dashboard): DashboardCreate => ({
  id: dashboard.id,
  name: dashboard.name,
  artifactType: dashboard.artifactType,
  keyTags: dashboard.keyTags,
  tags: dashboard.tags,
  description: dashboard.description || '',
  isCertified: dashboard.isCertified,
  showAll: dashboard.isShowAll,
  artifactUrl: checkArtifactUrl(
    dashboard.artifactType,
    dashboard.artifactId,
    dashboard.workspaceId,
  ),
  repositoryType: dashboard.repositoryType,
});

const checkArtifactUrl = (artifactType: string, artifactId: string, workspaceId?: string) => {
  if (artifactType === 'PowerBIRepository') {
    // eslint-disable-next-line max-len
    return `https://app.powerbi.com/Redirect?action=OpenReport&appId=${workspaceId}&reportObjectId=${artifactId}&ctid=${VITE_AZURE_AUTH_TENANT_ID}&reportPage=ReportSection75bef716ed2401c6d8a8&pbi_source=appShareLink&portalSessionId=1a35119b-19c7-4c08-9652-f58aaea7b945`;
  }
  if (artifactType === 'PowerApp') {
    return `https://apps.powerapps.com/play/e/default-${VITE_AZURE_AUTH_TENANT_ID}/a/${artifactId}`;
  }
  // eslint-disable-next-line max-len
  return `https://app.powerbi.com/groups/${workspaceId}/reports/${artifactId}/ReportSectionc27d90512a0aa9499832?experience=power-bi`;
};
